'use client';
import { IArticleCategory } from '@/src/interfaces/generated/contentful';
import { Box } from '@/src/packages/components/ui/Box';
import { Container } from '@/src/packages/components/ui/Container';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { getRoute } from '@/src/packages/utils/routes';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export const JournalCategoryLink = ({
  label,
  href,
  isActive,
}: {
  label: string;
  href: string;
  isActive: boolean;
}) => {
  return (
    <Link
      href={href}
      className="relative inline-block whitespace-nowrap pb-4 leading-none"
    >
      {label}
      {isActive && (
        <Box className="absolute bottom-0 h-[2px] w-full bg-[black]" />
      )}
    </Link>
  );
};

export const LayoutJournalCategories = ({
  categories,
}: {
  categories: IArticleCategory[];
}) => {
  const params = useParams<{ slug: string }>();

  const currentCategory = params?.slug;

  return (
    <Box className="border-b">
      <Container className="flex items-center space-x-8 overflow-scroll">
        <JournalCategoryLink
          isActive={!currentCategory}
          href={getRoute({
            route: paths.BLOG_INDEX,
          })}
          label="Latest"
        />

        {categories.map((category, i) => {
          const isActive = category.fields.slug === currentCategory;

          return (
            <JournalCategoryLink
              key={i}
              isActive={isActive}
              label={category.fields.name}
              href={getRoute({
                route: paths.BLOG_CATEGORY_INDEX,
                params: {
                  [pathParams.SLUG]: category.fields.slug,
                },
              })}
            />
          );
        })}
      </Container>
    </Box>
  );
};
